import withLoading from "./withLoading";

export default withLoading;
